import Axios from '@/plugins/Axios';
import { Pharmacy, PharmacyOrder, SubscriptionStatusString } from '@/types';

const endpoint = '/pharmacy';

const pharmacyApi = {
  getPharmacyList: (pharmacyId: number | null) => {
    const queryParam = pharmacyId ? `?id=${pharmacyId}` : '';
    return Axios().get<[Pharmacy] | []>(endpoint + queryParam);
  },
  getPharmacyOrder: (id: string, parmacyCode?: string | null) => {
    const params = parmacyCode ? `?pharmacy_code=${parmacyCode}` : '';
    return Axios().get<PharmacyOrder>(`${endpoint}/order/${id}${params}`);
  },
  updatePharmacyOrder: (
    id: string,
    body: { status: SubscriptionStatusString; pharmacy_code: string }
  ) => {
    return Axios().put(`${endpoint}/order/${id}`, body);
  },
};

export default pharmacyApi;
